import axios from 'axios';
import apiConfig from '../api.config';

export default function updateUserRequest({ id, ownerId, name, email, hotel, role, isSuperUser }) {
  const {
    host,
    URIs: { updateUser },
  } = apiConfig;

  const data = {
    ownerId,
    name,
    hotel,
    role,
  };

  if (isSuperUser) data.email = email;

  const uri = `${host}${updateUser}/${id}`;

  return axios
    .put(uri, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
